'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$88() {
  this.bIR = null;
  this.bIS = false;
}
export { $c_Lpresto_TwoFactorAuthView$$anon$88 as $c_Lpresto_TwoFactorAuthView$$anon$88 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$88.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$88;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$88() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$88 as $h_Lpresto_TwoFactorAuthView$$anon$88 };
$h_Lpresto_TwoFactorAuthView$$anon$88.prototype = $p;
$p.P = (function() {
  if ((!this.bIS)) {
    this.bIR = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T8($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$()));
    this.bIS = true;
  }
  return this.bIR;
});
var $d_Lpresto_TwoFactorAuthView$$anon$88 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$88, "presto.TwoFactorAuthView$$anon$88", ({
  Tt: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$88 as $d_Lpresto_TwoFactorAuthView$$anon$88 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$88.js.map
